/** Ruta pública `/ingresar` (T056 · US2): inicio de sesión del Admin. */
import { createFileRoute } from '@tanstack/react-router';

import { LoginPage } from '../features/auth/login-page';

export const Route = createFileRoute('/ingresar')({
  component: LoginPage,
});
